export * from './Product';
export * from './Navigation';
export * from './Query';
export * from './CollectionBook';

export type OSType = 'ANDROID' | 'IOS' | 'MWEBANDROID' | 'MWEBIOS' | 'WEB';
export type DeviceType = 'web' | 'mobileWeb' | 'mobile';
